/* eslint-disable react/jsx-sort-props */
// @flow

import React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import unreadBadgeStyles from './Styles/UnreadBadge.Style';

type Props = {}

const UnreadBadge = (props: Props) => {
  const theme = useTheme();

  return (
    <Box sx={unreadBadgeStyles.badgeCtr(theme)} />
  );
};

export default UnreadBadge;
